import {
    SET_CANDIDATE_LIST_FOR_JOB_POSITION,
    SET_SELECTED_CANDIDATE_FOR_JOB_POSITION
} from './constants';


export const initialJobPositionMeta = {};


export function jobPositionMeta(state = initialJobPositionMeta, action) {
    switch (action.type) {
        case SET_CANDIDATE_LIST_FOR_JOB_POSITION:
            return Object.assign({}, state, {
                [action.jobPositionId]: Object.assign({}, state[action.jobPositionId], {candidates: action.candidates})
            });
        case SET_SELECTED_CANDIDATE_FOR_JOB_POSITION:
            return Object.assign({}, state, {
                [action.jobPositionId]: Object.assign({}, state[action.jobPositionId], {selectedCandidate: action.candidate})
            });
        default:
            return state;
    }
}
